import React from 'react';
import { useTranslation } from 'react-i18next';
import { Formik, Form, Field } from 'formik';
import { toFormikValidationSchema } from 'zod-formik-adapter';
import Grid from 'apollo-react/components/Grid';
import { contactInfoSchema } from '../../../../validation/profileValidation';
import { renderInputComponent } from '../../Form/renderInputComponent';
import { formatPhoneForDisplay } from '../../../../utils/phoneUtils';
import ButtonCommon from '../../Button';
import ProfileFieldDisplay from './ProfileFieldDisplay';
import ProfileEditActions from './ProfileEditActions';
import styles from '../Profile.module.css';

const ContactInfoSection = ({
  form,
  setForm,
  editing,
  onStartEdit,
  onStopEdit,
  onSave,
  onDiscard,
  fields,
  canEdit,
}) => {
  const { t } = useTranslation();

  if (!editing) {
    return (
      <>
        <div className={styles.divider} />
        <ProfileFieldDisplay label={t('Email')} value={form.email} />
        <ProfileFieldDisplay
          label={t('profileData.phoneNumber')}
          value={form.phone}
        />
        {canEdit && (
          <div className={styles.actionsRight}>
            <ButtonCommon
              color="primary"
              className={styles.btnSized}
              onClick={onStartEdit}
              text={t('edit')}
            />
          </div>
        )}
      </>
    );
  }

  return (
    <Formik
      initialValues={{
        email: form.email,
        phone: form.phone || '',
        username: form.username,
      }}
      validationSchema={toFormikValidationSchema(contactInfoSchema(t))}
      enableReinitialize
      onSubmit={async () => {
        const success = await onSave('contact');
        if (success) onStopEdit();
      }}
    >
      {({ setFieldValue, handleSubmit }) => (
        <Form>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12 }}>
              {fields.map((field) => (
                <Field key={field.name} name={field.name}>
                  {({ field: formikField, meta }) =>
                    renderInputComponent(
                      field,
                      {
                        email: form.email,
                        phone: form.phone,
                        username: form.username,
                      },
                      formikField,
                      meta,
                      (value) => {
                        const finalValue =
                          field.type === 'phoneWithCountry'
                            ? formatPhoneForDisplay(value)
                            : value;
                        setFieldValue(formikField.name, finalValue);
                        setForm({
                          ...form,
                          [formikField.name]: finalValue,
                        });
                      }
                    )
                  }
                </Field>
              ))}
            </Grid>
          </Grid>
          <ProfileEditActions
            onDiscard={() => {
              onDiscard();
              onStopEdit();
            }}
            onSave={handleSubmit}
          />
        </Form>
      )}
    </Formik>
  );
};

export default ContactInfoSection;
